import { render, staticRenderFns } from "./RecordingPage.vue?vue&type=template&id=3240a826&"
import script from "./RecordingPage.vue?vue&type=script&lang=js&"
export * from "./RecordingPage.vue?vue&type=script&lang=js&"
import style0 from "./RecordingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports